export function TooltipProvider({ children }) {
  return children;
}
